import React from 'react';
import { observer } from "mobx-react-lite";
import { undoableCombatConfigurationCreateAndSelectEnemyCombatPreset } from '../../stores/undo/operation/CombatConfigurationSubmitChangesOp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlus } from '@fortawesome/free-solid-svg-icons';
import { undoableSelectEnemyCombatPreset } from '../../stores/undo/operation/CombatEnemyCombatPresetSelectionOp';
import { combatStore } from '../../stores/CombatStore';
import { gameStore } from '../../stores/GameStore';
import { editorStore } from '../../stores/EditorStore';
export const EnemyCombatPresetSelector = observer(({
  currentModelId,
  setModelId
}) => {
  if (!combatStore.config) return null;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("select", {
    value: currentModelId,
    onChange: e => setModelId(e.target.value)
  }, /*#__PURE__*/React.createElement("option", null), combatStore.config.enemyCombatPresets.map(preset => /*#__PURE__*/React.createElement("option", {
    key: preset.$modelId,
    value: preset.$modelId
  }, preset.name.get(gameStore.languageKey, true)))), editorStore.isMainGameEditor && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    disabled: !combatStore.config.findEnemyCombatPreset(currentModelId),
    onClick: () => undoableSelectEnemyCombatPreset(currentModelId)
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faEdit
  })), /*#__PURE__*/React.createElement("button", {
    onClick: () => undoableCombatConfigurationCreateAndSelectEnemyCombatPreset()
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faPlus
  }))));
});